export function isAlreadySignedOut(error) {
    return Boolean(error && error.response && error.response.status === 401);
}
